import { Currency, ETHER, Token } from '@magikswap/sdk'
import { useMemo } from 'react'
import styled from 'styled-components'
import { WrappedTokenInfo } from 'state/types'
import useHttpLocations from '../../hooks/useHttpLocations'
import getTokenLogoURL from '../../utils/getTokenLogoURL'
import Logo from './Logo'

const StyledLogo = styled(Logo)<{ size: string }>`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  border-radius: 50%;
`

export default function CurrencyLogo({
  currency,
  size = '24px',
  style,
  className,
}: {
  currency?: Currency
  size?: string
  style?: React.CSSProperties
  className?: string
}) {
  const uriLocations = useHttpLocations(currency instanceof WrappedTokenInfo ? currency.logoURI : undefined)
  const srcs: string[] = useMemo(() => {

    if (currency === ETHER) return ['https://baseswap.fi/images/tokens/0x2170Ed0880ac9A755fd29B2688956BD959F933F8.svg']
    if (currency?.symbol === 'ETH')
      return [`/images/tokens/${'0x2170Ed0880ac9A755fd29B2688956BD959F933F8'.toLowerCase()}.svg`]
    if (currency?.symbol === 'WETH')
      return [`/images/tokens/${'0x4200000000000000000000000000000000000006'.toLowerCase()}.png`]
    if (currency?.symbol === 'SMD')
      return [`/images/tokens/${'0xFDa619b6d20975be80A10332cD39b9a4b0FAa8BB'.toLowerCase()}.png`]
    if (currency?.symbol === 'xSMD')
      return [`/images/tokens/${'0xFb68BBfaEF679C1E653b5cE271a0A383c0df6B45'.toLowerCase()}.png`]
    if (currency?.symbol === 'USDT')
      return [`/images/tokens/${'0xf0F161fDA2712DB8b566946122a5af183995e2eD'.toLowerCase()}.png`]
    if (currency?.symbol === 'USDC')
      return [`/images/tokens/${'0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913'.toLowerCase()}.png`]
    if (currency?.symbol === 'DAI')
      return [`/images/tokens/${'0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb'.toLowerCase()}.png`]
    if (currency?.symbol === 'WBTC')
      return [`/images/tokens/${'0xcDd475325D6F564d27247D1DddBb0DAc6fA0a5CF'.toLowerCase()}.png`]
    if (currency?.symbol === 'USDbC')
      return [`/images/tokens/${'0xd9aAEc86B65D86f6A7B5B1b0c42FFA531710b6CA'.toLowerCase()}.png`]
    if (currency instanceof Token) {
      if (currency instanceof WrappedTokenInfo) {
        return [...uriLocations, `/images/tokens/${currency.address.toLowerCase()}.png`]
      }
      return [getTokenLogoURL(currency.address)]
    }
    // @ts-ignore
    return []
    // @ts-ignore
    // return currency?.address ? [`/images/tokens/${currency.address.toLowerCase()}.png`] : []
  }, [currency, uriLocations])

  return (
    <StyledLogo
      className={className}
      size={size}
      srcs={srcs}
      alt={`${currency?.symbol ?? 'token'} logo`}
      style={style}
    />
  )
}
